import React from "react";

function Loading (){
  return (
    <>
      loading
    </>
  );
}

export default Loading;